import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";
import {FlexSpace} from "./Layout.tsx";
import Logo from "./Logo.tsx";

interface Props {
    participant: "user" | "assistant";
    children: ReactNode;
}

const messageRowClass = css({
    display: 'flex',
    gap: '16px',
})

const baseMessageClass = css({
    background: "neutral.800",
    border: "1px solid",
    padding: "16px",
    gap: "8px"
})

const userMessageClass = css({
    borderRadius: '16px 4px 16px 16px',
    borderColor: "neutral.500"
})

const assistantMessageClass = css({
    borderRadius: '4px 16px 16px 16px',
    borderColor: "primary.500"
})

const participantIconClass = css({
    width: "24px",
    height: "24px",
    flexShrink: 0,
    flexBasis: "24px"
});


const MessageBubble: FC<Props> = ({participant, children}) => {
    if (participant === "assistant") {
        return <div className={messageRowClass}>
            <div className={participantIconClass}>
                <Logo size="small" />
            </div>
            <div className={cx(baseMessageClass, assistantMessageClass)}>
                {children}
            </div>
            <FlexSpace />
        </div>
    }

    return <div className={messageRowClass}>
        <div className={participantIconClass} />
        <FlexSpace />
        <div className={cx(baseMessageClass, userMessageClass)}>
            {children}
        </div>
    </div>
}

export default MessageBubble